<template>
  <div class="dark-overlay problems-comparator">
    <div class="head">
      <CloseButton @click.native="$emit('close')" />
      <div class="f-h f-w h-v-centerer">
        {{ similarity }}
      </div>
    </div>
    <PanelSplitter :allow-hiding="[false, false]">
      <div>
        <ProblemSheetModal :prop-id="base.id" in-popup show-only-problem-data />
      </div>
      <div>
        <ProblemSheetModal :prop-id="toCompare.id" in-popup show-only-problem-data />
      </div>
    </PanelSplitter>
  </div>
</template>

<script>

/**
 * Display a fullscreen page with two helf-width sections.
 * Each section display a problem (base on the left, to be compared on the right)
 * @vue-prop {Object} base - Original problem to be displayed on the left section
 * @vue-prop {Object} toCompare - Problem to compare base to. On the right
 * @vue-prop {Boolean} show - Whether the comparator should be displayed or not
 *
 * @vue-event {String, *} sheetEdit - Trasmitted from ProblemDataSection
 * @vue-event {Object} pictureClick - Trasmitted from ProblemDataSection
 */

import CloseButton from '@/components/close-button.vue';
import PanelSplitter from '@/components/panel-splitter.vue';

export default {

  name: 'ProblemsComparator',

  components: {
    CloseButton,
    PanelSplitter,
    ProblemSheetModal: () => import('@/components/edition-modals/problem-sheet-modal.vue'),
  },

  props: {
    base: {
      type: Object,
      required: true,
    },
    toCompare: {
      type: Object,
      required: true,
    },
  },

  computed: {
    /** Head title */
    similarity() {
      const { similarity } = this.toCompare;
      const perc = Number(similarity || 0) * 100;
      return this.$t('message.SIMILARITY_PERC_NEO', { perc: perc.toFixed(1) });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.problems-comparator.dark-overlay {
  background: #ffffff;
  text-align: initial;

  .head {
    height: 80px;
  }
  .panel-splitter {
    height: calc(100% - 80px);

    &__panel {

      &--hidden {
        padding: 0px;
      }
    }
  }
}
</style>
